import React from "react"
import { Box, Divider, FormControlLabel, Switch, TextField, Typography } from "@mui/material"
import { useFormikContext } from "formik"
import { t } from "i18next"
import { IDocumentFolder } from "pages/documents/interface/folder.interface"
import { StyledListItem } from "shared/styled/General"
import { StyledInputLabel } from "components/Form/FormComponents/FormSwitch/FormSwitch.styled"
import { TinyMCE, tinyMceImportDate } from "components/TinyMCE/TinyMCE"
import TextEditor from "components/Fields/TextEditor"
import { apiEndpoints } from "generated/apiEndpoints"
import { CustomRoleSelector } from "pages/documents/components/Form/CustomRoleSelector"
import { CompanyAndDepartmentSelector } from "pages/documents/components/Form/CompanyAndDepartmentSelector"

export const DocumentForm = ({ cretedDate, body, roleResult }: any) => {
  const { values, setFieldValue, handleChange, handleBlur, errors, touched } = useFormikContext<IDocumentFolder>()

  return (
    <Box display="flex" flexDirection="column" height="100%" gap={2}>
      <StyledListItem>
        <StyledInputLabel>
          <Typography color="black" variant="labelMedium" fontWeight={600}>
            {t(`documents.folder_form.name`, "Name")}
          </Typography>
        </StyledInputLabel>
        <TextField
          autoComplete="off"
          fullWidth
          id="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.name && errors.name ? true : false}
          helperText={touched.name && errors.name ? errors.name : null}
          variant="outlined"
        />
      </StyledListItem>
      <StyledListItem>
        <StyledInputLabel>
          <Typography color="black" variant="labelMedium" fontWeight={600}>
            {t(`documents.folder_form.description`, "Description")}
          </Typography>
        </StyledInputLabel>
        <TextField
          multiline
          minRows={2}
          autoComplete="off"
          fullWidth
          id="description"
          value={values?.description}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.description && errors.description ? true : false}
          helperText={touched.description && errors.description ? errors.description : null}
          variant="outlined"
        />
      </StyledListItem>
      <StyledListItem>
        <StyledInputLabel>
          <Typography color="black" variant="labelMedium" fontWeight={600}>
            {t(`documents.folder_form.bodytext`, "Bodytext")}
          </Typography>
        </StyledInputLabel>
        {(new Date(cretedDate) <= new Date(tinyMceImportDate)) ? (
          <TextEditor
            value={body}
            setData={(e: any) => {
              setFieldValue("body", e)
            }}
            uploadApi={apiEndpoints.documents.uploadattachment}
          />
        ) : (
          <TinyMCE
            formikValues={values}
            setFormikData={(e: any) => {
              setFieldValue("body", e)
            }}
            uploadMediaUrl={apiEndpoints.documents.uploadattachment}
          />
        )}
      </StyledListItem>
      <StyledListItem>
        <FormControlLabel
          control={
            <Switch
              onChange={(e) => {
                setFieldValue("isVisibleStartPage", e.target.checked)
              }}
              id="company"
              checked={values.isVisibleStartPage}
            />
          }
          label={t(`documents.folder_form.list_startpage`, "Show on home page")}
        />
      </StyledListItem>
      {roleResult.status === 2 && (
        <>
          <Divider />
          <CustomRoleSelector roleResult={roleResult} />
        </>
      )}
      <Divider />
      <CompanyAndDepartmentSelector />
      <Divider />
    </Box>
  )
}